import e from"styled-components";import{COLORS as i,FONTS as t}from"../constants/Theme.js";const o=e=>e+"px",n=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.titleXLarge.fontWeight};
	font-size: ${o(t.titleXLarge.fontSize)};
	line-height: ${o(t.titleXLarge.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,l=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.titleLarge.fontWeight};
	font-size: ${o(t.titleLarge.fontSize)};
	line-height: ${o(t.titleLarge.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,r=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.titleMedium.fontWeight};
	font-size: ${o(t.titleMedium.fontSize)};
	line-height: ${o(t.titleMedium.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,a=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.title4.fontWeight};
	font-size: ${o(t.title4.fontSize)};
	line-height: ${o(t.title4.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,f=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.titleRegular.fontWeight};
	font-size: ${o(t.titleRegular.fontSize)};
	line-height: ${o(t.titleRegular.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,b=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.titleSmall.fontWeight};
	font-size: ${o(t.titleSmall.fontSize)};
	line-height: ${o(t.titleSmall.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,d=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.display.fontWeight};
	font-size: ${o(t.display.fontSize)};
	line-height: ${o(t.display.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,c=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.bodyPrimary.fontWeight};
	font-size: ${o(t.bodyLarge.fontSize)};
	line-height: ${o(t.bodyLarge.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,h=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.bodyPrimary.fontWeight};
	font-size: ${o(t.bodyPrimary.fontSize)};
	line-height: ${o(t.bodyPrimary.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,g=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.bodySecondary.fontWeight};
	font-size: ${o(t.bodySecondary.fontSize)};
	line-height: ${o(t.bodySecondary.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,w=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.bodySecondary.fontWeight};
	font-size: ${o(t.bodySecondary.fontSize)};
	line-height: ${o(t.bodySecondary.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
	z-index: 1;
	background: linear-gradient(93deg, #ff166a 0.37%, #fb5f08 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	text-fill-color: transparent;
`,$=e(h)`
	text-decoration: underline;
	color: ${i.content.brand};
	text-decoration-color: ${i.content.brand};
	cursor: pointer;
`,m=e(g)`
	text-decoration: underline;
	color: ${i.content.brand};
	text-decoration-color: ${i.content.brand};
	cursor: pointer;
`,p=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.caption.fontWeight};
	font-size: ${o(t.caption.fontSize)};
	line-height: ${o(t.caption.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
	word-break: break-word;
	overflow-wrap: break-word;
`,y=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.caption.fontWeight};
	font-size: ${o(t.caption.fontSize)};
	line-height: ${o(t.caption.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
	z-index: 1;
	background: linear-gradient(93deg, #ff166a 0.37%, #fb5f08 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	text-fill-color: transparent;
`,x=e.div`
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.tiny.fontWeight};
	font-size: ${o(t.tiny.fontSize)};
	line-height: ${o(t.tiny.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,k=e.div`
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.tiny.fontWeight};
	font-size: ${o(t.tiny.fontSize)};
	line-height: ${o(t.tiny.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
	z-index: 1;
	background: linear-gradient(93deg, #ff166a 0.37%, #fb5f08 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	text-fill-color: transparent;
`,s=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.buttonLarge.fontWeight};
	font-size: ${o(t.buttonLarge.fontSize)};
	line-height: ${o(t.buttonLarge.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,v=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.buttonLarge.fontWeight};
	font-size: ${o(t.buttonLarge.fontSize)};
	line-height: ${o(t.buttonLarge.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
	background: linear-gradient(93deg, #ff166a 0.37%, #fb5f08 100%);
	z-index: 1;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	text-fill-color: transparent;
`,u=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.buttonRegular.fontWeight};
	font-size: ${o(t.buttonRegular.fontSize)};
	line-height: ${o(t.buttonRegular.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,z=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.subHeading.fontWeight};
	font-size: ${o(t.subHeading.fontSize)};
	line-height: ${o(t.subHeading.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,L=e.div`
	font-family: Inter;
	color: ${e=>e.color||i.text.primary};
	font-weight: ${t.bodyRegular.fontWeight};
	font-size: ${o(t.bodyRegular.fontSize)};
	line-height: ${o(t.bodyRegular.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,S=e.div`
	font-family: Inter;
	color: ${i.text.primary};
	font-weight: ${t.caption.fontWeight};
	font-size: ${o(t.caption.fontSize)};
	line-height: ${o(t.caption.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,H=e.div`
	font-family: Inter;
	color: ${i.text.primary};
	font-weight: ${t.textPlaceholder.fontWeight};
	font-size: ${o(t.textPlaceholder.fontSize)};
	line-height: ${o(t.textPlaceholder.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,O=e.div`
	font-family: Inter;
	color: ${i.text.primary};
	font-weight: ${t.title4.fontWeight};
	font-size: ${o(t.title4.fontSize)};
	line-height: ${o(t.title4.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,W=e.div`
	font-family: Inter;
	color: ${i.text.primary};
	font-weight: ${t.bodySmall.fontWeight};
	font-size: ${o(t.bodySmall.fontSize)};
	line-height: ${o(t.bodySmall.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,I=e.div`
	font-family: Inter;
	color: ${i.text.primary};
	font-weight: ${t.captionBold.fontWeight};
	font-size: ${o(t.captionBold.fontSize)};
	line-height: ${o(t.captionBold.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`,R=e.div`
	font-family: Inter;
	color: ${i.text.primary};
	font-weight: ${t.tiny.fontWeight};
	font-size: ${o(t.tiny.fontSize)};
	line-height: ${o(t.tiny.lineHeight)};
	-webkit-box-orient: vertical;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: ${e=>e.numberOfLines};
`;export{y as AiBodyCaption,k as AiBodyTiny,p as BodyCaption,c as BodyLarge,h as BodyPrimary,$ as BodyPrimaryLink,L as BodyRegular,g as BodySecondary,m as BodySecondaryLink,W as BodySmall,x as BodyTiny,s as ButtonLarge,v as ButtonLargeAI,u as ButtonRegular,w as ButtonRegularAI,S as Caption,I as CaptionBold,d as Display,a as SmallRegular,z as SubHeading,H as TextPlaceholder,R as Tiny,O as TitleFour,l as TitleLarge,r as TitleMedium,f as TitleRegular,b as TitleSmall,n as TitleXlarge};
